import { Flex, IconButton, Text, useTheme } from '@chakra-ui/react';
import { CrossIcon, DragIcon, PlusIcon } from '../../icons';

export const PermanentItem = ({
  column,
  isHidden,
  handleTogglePermanentColumn,
  componentOrigin,
}: {
  column: any;
  isHidden: boolean;
  handleTogglePermanentColumn?: (column: string) => void;
  componentOrigin?: string;
}) => {
  const { colors } = useTheme();
  const disablePlusIcon =
    (componentOrigin === 'team-table' && column === 'Teams') ||
    column === 'Contributors';
  return (
    <Flex
      px={2}
      py={1}
      bg={isHidden ? '#F5F5F5' : '#EAEAFB'}
      borderRadius={4}
      justify={'space-between'}
      outline={`1px solid ${isHidden ? '#D0D0D0' : '#E2E2E7'}`}
      align={'center'}
      opacity={isHidden ? 0.6 : 1}
    >
      <Flex gap={1} align={'center'}>
        <IconButton
          icon={<DragIcon fill={'grey'} />}
          aria-label="drag-button"
          cursor={'grab'}
          size={'sm'}
          opacity={0.25}
          p={0}
          isDisabled
        />
        <Text
          fontSize={'sm'}
          color={isHidden ? 'text.secondary' : 'text.primary'}
        >
          {column}
        </Text>
      </Flex>
      <IconButton
        icon={
          isHidden ? (
            <PlusIcon
              fill={colors.primary}
              color={colors.primary}
              height={20}
              width={20}
            />
          ) : (
            <CrossIcon
              fill={disablePlusIcon ? 'grey' : colors.primary}
              color={disablePlusIcon ? 'grey' : colors.primary}
              height={20}
              width={14}
            />
          )
        }
        aria-label={isHidden ? 'show-column' : 'hide-column'}
        size={'sm'}
        p={0}
        background={'transparent'}
        onClick={() => {
          if (handleTogglePermanentColumn) {
            handleTogglePermanentColumn(column);
          }
        }}
        maxW={250}
        overflow={'hidden'}
        isDisabled={disablePlusIcon}
        opacity={disablePlusIcon ? 1 : 0.75}
      />
    </Flex>
  );
};
